import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { PlanFeature, ResponseJson } from '../models/model';
import { environment } from '../../../environments/environment.dev';
import { IPlan } from 'src/app/pricing/models';

@Injectable({ providedIn: 'root' })
export class PlanService extends BaseService {
    private apiUrl = environment.apiUrl + '/admin-sales';

    getPlansByFeature(feature: PlanFeature): Observable<ResponseJson<IPlan[]>> {
        return this.get<IPlan[]>(`${this.apiUrl}/plans/by-feature`, { feature });
    }

    getPlans() {
        return this.get<IPlan[]>(`${this.apiUrl}/plans`);
    }

    sendUserDataToContactSales(planName: string) {
        return this.post<any>(`${this.apiUrl}/send-user-data-to-contact-sales`, { planName });
    }
}
